const Distribution = {
    isMemberPickupLocationOk: function (distribution, member, invoice, pickupLocations) {
        const excludedLocations = distribution.unavailablePickupLocations;
        const pickupLocationId = invoice === null ? member.PickupLocationId : invoice.PickupLocationId;
        const isPickupLocationAvailable = pickupLocations.some(location => {
            return location.id === pickupLocationId;
        });
        return isPickupLocationAvailable && excludedLocations.indexOf(pickupLocationId) === -1;
    }
}
export default Distribution;
